import css from "styled-jsx/css";
import colors from "styles/colors";
import { TABLET_QUERY_MAX_WIDTH, MOBILE_QUERY_MAX_WIDTH, XS } from "constants/vp-sizes";

export const componentStyles = css`
  .hotdog-header-component {
    position: relative;
    width: 100vw;

    .hotdog {
      content: "";

      width: 132vw;
      height: 132vw;

      position: absolute;
      bottom: 0;
      left: -16vw;

      z-index: 0;

      border-radius: 50%;

      @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
        width: 136vw;
        height: 136vw;

        left: -18vw;
      }

      @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
        width: 220vw;
        height: 220vw;

        left: -60vw;
      }
    }
  }
`;
